export default __webpack_public_path__ + "static/media/330_dummy2016-weinhandel01-de.f59119a0.png";